import { InjectionToken } from "@angular/core";

import { MatGlobalConfig } from "./model";

export const MAT_GLOBAL_CONFIG = new InjectionToken<MatGlobalConfig>("matGlobalConfig");

/**
 * @internal
 */
export const _MAT_GLOBAL_CONFIG = new InjectionToken<MatGlobalConfig | (() => MatGlobalConfig)>("_matGlobalConfig");
